import { boxShadows } from '@eversports/design-tokens/box-shadows'
import useMediaQuery from '@eversports/klimt-design-components/use-media-query'
import useTheme from '@eversports/klimt-design-components/use-theme'
import Box from '@eversports/klimt-primitives/legacy/Box'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import * as React from 'react'

import type { MatchSport } from '../../../../../App.types'
import ContainedXLWidthContainer from '../../../../../components/ContainedXLWidthContainer'
import type { Action } from '../helpers/matches-filters-reducer'
import type { MatchesFiltersState } from '../Matches.types'

import DateFilter from './DateFilter'
import ResetFilters from './ResetFilters'
import SportsFilter from './SportsFilter'

interface Props {
  sports?: Array<MatchSport>
  appliedFilters: MatchesFiltersState
  dispatch: React.Dispatch<Action>
}

const Filters = ({ sports, appliedFilters, dispatch }: Props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box sx={{ backgroundColor: 'lightgray', boxShadow: boxShadows.default, paddingX: { xs: 0, lg: 8 } }}>
      <ContainedXLWidthContainer>
        <Stack direction="row" gap={4} paddingY={2} paddingX={{ xs: 5, md: 0 }}>
          <SportsFilter
            dispatch={dispatch}
            sports={sports}
            selectedSports={appliedFilters.sports}
            isMobile={isMobile}
          />
          <DateFilter selectedDate={appliedFilters.date} dispatch={dispatch} isMobile={isMobile} />
          <ResetFilters appliedFilters={appliedFilters} dispatch={dispatch} />
        </Stack>
      </ContainedXLWidthContainer>
    </Box>
  )
}

export default Filters
